import ChevronUpIcon from "../images/ChevronUpIcon.mjs";

/**
 * App icon representing zoom level increasing
 * @see {GlyphIcon}
 * @see {ChevronUpIcon}
 */
const AppZoomInIcon = class extends ChevronUpIcon {};

export default AppZoomInIcon;